import { Row } from 'components/shared/Layout';
import styled from 'styled-components';
import { ifProp } from 'styled-tools';

import { colours } from 'themes/default';

export const StyledFareCondition = styled(Row)`
  background: ${colours.Greyscale.MistGrey};
  margin-top: 8px;
`;
export const TravelDate = styled.p`
  line-height: 24px;
  font-weight: 600;
  text-decoration: underline;
  color: ${colours.Greyscale.CharcoalGrey};
  display: inline-block;
  margin: 0 0 20px 0;
`;

export const FareConditionsContainer = styled(Row)`
  margin-top: 16px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-column-gap: 15px;
  grid-row-gap: 8px;
  grid-template-columns: repeat(4, auto);
  font-weight: normal;
  word-break: break-word;
`;

export const InfoGridHeaderCell = styled.div`
  font-weight: bold;
  padding: 0;
`;

export const InfoGridCell = styled.div`
  ${ifProp('column', ({ column }) => `grid-column: ${column};`)}
  padding: 0;
`;
